import React from 'react'
import { Link } from 'react-router-dom'

const CodeOfConductPage = () => {
    return (
        <div className="container Privacy-Page">
            <div className="justify-content-center align-items-center">
                <div className="font-500-44 ms-2 mb-3 mt-2 Privacytitle">
                    Code of Conduct
                </div>
                <div className="d-block justify-content-center pt-2 ms-2">
                    <p className="font-300-15">
                        As a user of the Service made available by Fan1 LLC, you must adhere to the following Fan1 Code of Conduct.
                        We developed the Code of Conduct to ensure that all users have a safe and positive experience at Fan1.
                        Any violations of the Code of Conduct may result in suspension or termination of a user's account, in
                        addition to any other actions we deem necessary.
                    </p>
                    <p className="font-300-15">
                        If you believe a violation of the Code of Conduct or the Terms of Service has occurred, or if you have any concern about Fan1,
                        please report the issue by emailing us at codeviolation@fan1.com. The Code of Conduct is an integral part of our Terms of Service,
                        and is incorporated into the Terms of Service. All capitalized terms not otherwise defined in the Code of Conduct shall have the
                        meaning given to them in the Terms of Service.
                    </p>

                    <p className="font-300-15">
                        <span className="spanterms">General Misuse of Fan1</span>.
                        You may only use our Service for its intended use and as permitted under the <Link to="/terms" className="text-decoration-undeline text-white">Terms of Service</Link>. You are solely responsible
                        for your use of our Service, including your account and any content you create. You may not use the Service to engage in
                        unauthorized commercial activity or to facilitate a transaction off our Site or through another platform. The following are
                        considered a misuse of the Service:
                    </p>

                    <p>
                        <p className="font-300-15">
                            • Sending advertisements, commercial messages, unsolicited communications or spam.
                        </p>
                        <p className="font-300-15">
                            • Using the Service to deceive or mislead others, including making bids or requests that you know (or should know) are false or unrealistic.
                        </p>
                        <p className="font-300-15">
                            • Creating multiple accounts, providing false identity information, or creating accounts using another person's name.
                        </p>
                        <p className="font-300-15">
                            • Transferring or selling, or offering to transfer or sell, or otherwise attempting to monetize your account.
                        </p>
                    </p>


                    <p className="font-300-15">
                        <span className="spanterms">Illegal Conduct</span>.
                        You are required to use the Service in compliance with all applicable laws. You are strictly prohibited from
                        using the Service to engage in, encourage, or promote any illegal conduct in the jurisdiction in which you
                        reside. You may not create content or submit requests that violate any law, regulation, court order,
                        or other legal process.
                    </p>

                    <p className="font-300-15">
                        <span className="spanterms">Violence</span>.
                        You are strictly prohibited from threatening, encouraging, or depicting violence or physical harm towards
                        anyone, including Notable Persons. You may not send, post, or solicit content that promotes or encourages
                        any form of violence or physical harm.
                    </p>

                    <p className="font-300-15">
                        <span className="spanterms">Bullying and Harassment</span>.
                        Bullying and harassment will not be tolerated on the Site, including of Notable Persons. You may not insult
                        anyone because of their personality traits, appearance, gender, sex, sexual orientation, race, or nationality.
                        You may not engage in any activity on the Site that is abusive, racist, harassing, or harmful to others.
                        There is a zero-tolerance policy for such actions.
                    </p>

                    <p className="font-300-15">
                        <span className="spanterms">Intellectual Property Violations</span>.
                        You may only submit content that you own or have the right to submit. You agree not to infringe, misappropriate,
                        or violate any privacy or intellectual property rights of others when using the Service.
                    </p>

                    <p className="font-300-15">
                        <span className="spanterms">Invasions of Privacy</span>.
                        We prohibit any content that violates the privacy or confidentiality of others, including disclosing others'
                        personal information without their permission. Please review our <Link to="/privacy" className="text-decoration-undeline text-white">Privacy Notice</Link> for more information
                        on how we collect, use, and share personal information.
                    </p>

                    <p className="font-300-15">
                        <span className="spanterms"> Prohibition on Disparaging and Hateful Speech</span>.
                        In order to ensure the Site stays a welcoming place for all users, you may not:
                    </p>

                    <p>
                        <p className="font-300-15">
                            • Use hateful or disparaging speech or derogatory terms.
                        </p>
                        <p className="font-300-15">
                            • Send, post, or solicit content that demeans, ridicules, or discriminates others.
                        </p>
                        <p className="font-300-15">
                            • Post content that supports organizations who advocate for hate, violence, or discrimination.
                        </p>
                    </p>

                    <p className="font-300-15">
                        <span className="spanterms">Explicit Content</span>.
                        Fan1 is not the place to send or request sexually explicit content. You may not send, post, or solicit indecent,
                        pornographic, or sexually explicit content. This prohibition applies to implied or actual activity and includes
                        digitally manufactured or manipulated content. We may make the determination as to what content is inappropriate in our sole discretion.
                    </p>

                    <p className="font-300-15">
                        <span className="spanterms">Undermining the Security or Reliability of the Service</span>.
                        You are strictly prohibited from any hacking attempts, efforts to undermine or bypass our security measures,
                        or any attempts to undermine the reliability of the Service.
                    </p>

                    <p className="font-300-15">
                        This User Code of Conduct provides examples and is not intended to be complete or exhaustive. We don’t have an
                        obligation to monitor your access to, or use of, the Service. We do, however, reserve the right to do so for the
                        purpose of operating the Service, to ensure your compliance with our Terms of Service, or to comply with applicable
                        law or the order or requirement of a court, administrative agency, or other governmental body. We reserve the right,
                        at any time and without prior notice, to remove or disable access to your account or any content that we consider,
                        in our sole discretion, to be in violation of the Code of Conduct or Terms or Service, or otherwise harmful to the Service.
                    </p>


                    <p className="font-300-15">
                        We reserve the right to seek all remedies available at law and in equity for violations of the Code of Conduct
                        or Terms of Service. We may, in our sole discretion, block access to the Service from a particular IP address.
                        Any termination of the Service does not limit or affect any other rights that we may have. Further, by breaching
                        this Code of Conduct, you may commit a criminal offense under applicable law. We reserve the right to report any
                        breach to the relevant law enforcement authorities and we may cooperate with those authorities.
                    </p>

                    <p className="font-300-15">
                        Last updated April 15, 2025
                    </p>
                </div>
            </div>
        </div>
    )
}

export default CodeOfConductPage